module.exports = __webpack_public_path__ + "assets/img/sun-min.a1e355d7.png";